module.exports = __webpack_public_path__ + "img/Puente_Istobal_M1_Alto_Blanco-default-back.4c53675a.jpg";